<template lang="pug">
.login-form
  title-main.login-form__title.align-center
    slot(name='loginTitle')
  .login-form__content
    .login-form__content__invalid(v-if='allErrorMessages.length > 0')
      .login-form__content__invalid__message(v-for='message in allErrorMessages') {{ message }}
    .login-form__content__input
      .login-form__content__input__label.text-small
        slot(name='accountCodeLabel')
      textbox-base.login-form__content__input__textfield(v-model='accountCode')
    .login-form__content__input
      .login-form__content__input__label.text-small
        slot(name='passwordLabel')
      textbox-base.login-form__content__input__textfield(type='password', v-model='password')
    button-primary.login-form__content__button(@click='doLogin')
      slot(name='loginButtonLabel')
  link-base.login-form__link(@click='moveLinkEvent')
    slot(name='moveLinkText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitleMain from '@/components/atoms/TitleMain.vue'
import TextboxBase from '@/components/atoms/TextboxBase.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import { InputPatternSetting } from '@/const/DisplaySettings'

/**
 * ログイン画面（フォーム）
 */
@Component({
  components: {
    TitleMain,
    TextboxBase,
    ButtonPrimary,
    LinkBase,
  },
})
export default class LoginForm extends Vue {
  // ログインボタン押下時イベント
  @Prop()
  loginButtonEvent!: Function

  // 移動リンク押下時イベント
  @Prop()
  moveLinkEvent!: Function

  // エラーメッセージ
  @Prop()
  errorMessages!: string[]

  // === 入力値を保持する変数群
  // ID
  public accountCode = ''
  // パスワード
  public password = ''

  // IDパターン不一致エラーメッセージ
  private patternErrorMessage = ''

  // 全てのエラーメッセージ
  private get allErrorMessages(): string[] {
    return this.errorMessages.concat([this.patternErrorMessage])
  }

  // ログイン実行
  private async doLogin() {
    this.patternErrorMessage = ''
    // IDのパターンに不一致の場合はエラーを返してログイン処理を行わない
    if (!this.accountCode.match(InputPatternSetting.ACCOUNT_PATTERN)) {
      this.patternErrorMessage = InputPatternSetting.ACCOUNT_PATTERN_ERROR_MESSAGE
      return
    }

    await this.loginButtonEvent()
  }
}
</script>

<style lang="stylus" scoped>
.login-form
  margin 100px auto 0
  max-width 500px

  &__content
    margin-bottom 10px

    &__invalid
      &__message
        color var(--color-login-alert__text)

    &__input
      margin-bottom 10px

      &__textfield
        width 100%
    &__button
      margin-top 50px

  &__link
    display flex
    justify-content center
    color var(--color-default__link-text)
</style>
